module.exports = __webpack_public_path__ + "static/media/talk00_medium.ccb96a60.jpg";